'use client';

import { I18nLink } from '@/components/i18n/I18nLink';
import { Avatar, Box, Text, VStack } from '@chakra-ui/react';

interface CategoryAvatarItemProps {
  href: string;
  label: string;
  imageSrc?: string;
  isActive?: boolean;
  isPrevented?: boolean;
  isOpacityMode?: boolean;
  isLogoMode?: boolean;
  size?: string;
}

export const CategoryAvatarItem: React.FC<CategoryAvatarItemProps> = ({
  href,
  label,
  imageSrc,
  isActive = false,
  isPrevented = false,
  isOpacityMode = false,
  isLogoMode = false,
  size = '70px',
}) => {
  return (
    <I18nLink href={href}>
      <VStack
        pt="4px"
        className="group"
        gap="5px"
        align="center"
        cursor={isActive ? 'default' : 'pointer'}
      >
        <Avatar.Root
          css={{ boxSizing: 'border-box' }}
          variant="outline"
          boxSize={`calc(${size})`}
          transition="transform 120ms ease, box-shadow 120ms ease"
          boxShadow={isActive || isPrevented ? '0px 0px 0px 3px' : '0px 0px 0px 1px'}
          boxShadowColor="gray.solid"
          _groupHover={{
            boxShadow: '0px 0px 0px 3px'
          }}
          style={{ WebkitBackfaceVisibility: 'hidden' }}
        >
          <Avatar.Fallback name={label} />
          {imageSrc && (
            <Avatar.Image
              src={imageSrc}
              opacity={isActive || isPrevented ? 1 : isOpacityMode ? 0.5 : 1}
              _groupHover={{ opacity: 1 }}
              scale={isLogoMode ? 0.7 : undefined}
              borderRadius={isLogoMode ? 0 : undefined}
              objectFit={isLogoMode ? "contain" : undefined}
            />
          )}
        </Avatar.Root>

        {/* Text wrapper */}
        <Box
          position="relative"
          minW="80px"
          maxW="140px"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          height="20px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {/* in-flow text */}
          <Text
            as="span"
            fontSize="14px"
            lineHeight="20px"
            fontWeight={isActive ? 700 : 400}
            textAlign="center"
            textTransform="lowercase"
            transition="opacity 120ms ease"
            _groupHover={{ opacity: 0 }}
          >
            {label}
          </Text>

          {/* overlay bold */}
          <Text
            as="span"
            position="absolute"
            inset={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="14px"
            lineHeight="20px"
            fontWeight={700}
            textAlign="center"
            textTransform="lowercase"
            opacity={0}
            pointerEvents="none"
            transition="opacity 120ms ease"
            _groupHover={{ opacity: 1 }}
          >
            {label}
          </Text>
        </Box>
      </VStack>
    </I18nLink>
  );
};
